import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { cn } from 'root/src/client/v2/common/helpers/cn';
const FAQ_ITEMS = [
    {
        q: 'What is a Drop?',
        a: 'A Drop is a sponsored campaign where publishers offer rewards to creators who stream their game and complete Dares for their community.',
    },
    {
        q: 'What is a Dare?',
        a: 'A Dare is a fun challenge tied to a Drop. Accept it, stream the game, and complete the objective to unlock the reward.',
    },
    {
        q: 'How do I participate?',
        a: 'Connect your streaming channel, accept a Dare from this Drop, then stream the game and deliver the Dare to earn your reward.',
    },
    {
        q: 'What rewards can I earn?',
        a: 'Rewards vary per Dare and can include game keys, codes, custom prizes, or points, plus keys to give away to your viewers.',
    },
    {
        q: 'Are there requirements?',
        a: 'Some Dares require a minimum viewership on a given platform. If you do not meet the requirement yet, keep growing and check back.',
    },
];
export const DropFaqSection = () => {
    const [open, setOpen] = useState(0);
    return (<section id="faq" className="scroll-mt-40 px-4 py-12 sm:px-6 lg:px-8">
			<div className="mx-auto max-w-3xl">
				<h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl">FAQ</h2>
				<div className="mt-6 space-y-2">
					{FAQ_ITEMS.map((item, index) => {
            const isOpen = open === index;
            return (<div key={item.q} className="overflow-hidden rounded-xl border border-solid border-white/[0.06] bg-card">
								<button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left text-sm font-medium text-foreground transition-colors hover:bg-white/[0.03]">
									{item.q}
									<ExpandMoreIcon sx={{ fontSize: 18 }} className={cn('shrink-0 text-muted-foreground transition-transform', isOpen && 'rotate-180')}/>
								</button>
								<AnimatePresence initial={false}>
									{isOpen && (<motion.div key="content" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25, ease: 'easeOut' }} className="overflow-hidden">
											<p className="px-4 pb-4 text-sm leading-relaxed text-muted-foreground">{item.a}</p>
										</motion.div>)}
								</AnimatePresence>
							</div>);
        })}
				</div>
			</div>
		</section>);
};
